var delayInMilliseconds = 3000; //3 second

setTimeout(function() {
  //your code to be executed after 1 second


// Cache selectors
var lastId,
 topMenu = jQuery("#sticky-nav__links"),
 topMenuHeight = topMenu.outerHeight()+1,
 // All list items
 menuItems = topMenu.find("a"),
 // Anchors corresponding to menu items
 scrollItems = menuItems.map(function(){
   var item = jQuery(jQuery(this).attr("href"));
    if (item.length) { return item; }
 });

// Bind click handler to menu items
// so we can get a fancy scroll animation
menuItems.click(function(e){
  var href = jQuery(this).attr("href"),
      offsetTop = href === "#" ? 0 : jQuery(href).offset().top-topMenuHeight+1;
  jQuery('html, body').stop().animate({ 
      scrollTop: offsetTop
  }, 850);
  e.preventDefault();
});

// Bind to scroll
jQuery(window).scroll(function(){
   // Get container scroll position
   var fromTop = jQuery(this).scrollTop()+topMenuHeight;
   
   // Get id of current scroll item
   var cur = scrollItems.map(function(){
     if (jQuery(this).offset().top < fromTop)
       return this;
   });
   // Get the id of the current element
   cur = cur[cur.length-1];
   var id = cur && cur.length ? cur[0].id : "";
   
   if (lastId !== id) {
       lastId = id;
       // Set/remove active class
       menuItems
         .parent().removeClass("active")
         .end().filter("[href='#"+id+"']").parent().addClass("active");
   }                   
});

$( document ).ready(function() {
    setTimeout(function() {
      var dys = $('#CartPageForm .wi-advance-delivery-dt-datepicker-days .wi-advance-delivery-dt-datepicker-switch');
      $('#CartPageForm .wi-advance-delivery-dt-datepicker-days .prev').before(dys);
      $('#CartPageForm .wi-advance-delivery-dt-datepicker-days .prev').html('<div class="cust_arrowprev"></div>');
      $('#CartPageForm .wi-advance-delivery-dt-datepicker-days .next').html('<div class="cust_arrownext"></div>');
      $('#CartPageForm .wi-advance-delivery-dt-datepicker-days .day').each(function(){
        var txt = $(this).html();
        $(this).html('<strong class="strng">'+ txt +'</strong>');
      });
      var delvry = $('#CartPageForm .iw-order-delivery-dt-main');
      $('.calend_wrap').html(delvry);
    }, 1000);

    setInterval(function() {
      $('.calend_wrap .wi-advance-delivery-dt-datepicker-days .day').each(function(){
        if(!$(this).find('.strng').length) {
          var txt = $(this).html();
          $(this).html('<strong class="strng">'+ txt +'</strong>');
        }
      });
    }, 1000);

    /*var intervalId = setInterval(function() {
        var vle = $('.new-cart-page .iw-order-delivery-dt-deliveryDateVal').val();
        if(vle != '') {
          $('.error_input').remove();
          $('.cart__checkout-wrapper').addClass('active');
          clearInterval(intervalId);
        }
    }, 500);*/

    if ($(window).width() <= 500) {
      var crt = $('.deskvew .cart-table-wrap-new');
      $('.tble-mb .cwrap').before(crt);
      var coupn = $('.deskvew .coupon_new');
      $('.tble-mb .cwrap').html(coupn);
      var cponmsg = $('.deskvew .disc_msg');
      $('.tble-mb .coupon_new').before(cponmsg);
    }

    $('body').on('click', '.custm_checkoutbtn', function (e) {
         e.preventDefault();
          var vle = $('.new-cart-page .iw-order-delivery-dt-deliveryDateVal').val();
          $('.error_input').remove();
          if(vle == '') {
            $(this).closest('.cart__checkout-wrapper').before('<div class="error_input">Please select a Delivery Date.</div>');
          } else if(vle != '') {
              $(this).next('.cart__checkout').trigger('click');
          }
    });

    

    $('body').on('click', '.apply_disc', function (e) {
        e.preventDefault();
        var $this = $(this);
        var vle = $('.new-cart-page .iw-order-delivery-dt-deliveryDateVal').val();
        var discount = $(this).closest('.coupon_new').find('#discount_code').val();
        $('.error_input').remove();
        if(discount == '') {
          $(this).closest('.coupon_new').after('<div class="error_input">You need to enter the Coupon Code</div>');
        } else {
          $(this).addClass('loading');
          
          fetch('/discount/'+discount)
          .then(function() {
            // After the discount code has been applied, force the cart to update so the discount is visible
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                updates: {},
              })
            }).then(response => response.json())
            .then(data => {
              // Check if the discount was applied successfully
              if (data.total_discount > 0) {
                $this.closest('.coupon_new').after('<div class="error_input">Coupon applied successfully!</div>');
                location.reload();
              } else {
                $this.removeClass('loading');
                $this.closest('.coupon_new').after('<div class="error_input">'+ discount +' discount code isn’t valid for the items in your cart</div>');
              }
            });
          })
          .catch(function(error) {
            $this.removeClass('loading');
            console.error('Error:', error);
          });
          
        }
    });
});

}, delayInMilliseconds);